import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DIMixins } from "@/core/@types/types";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { IF360ClosersValidator } from "./F360ClosersValidator";

@injectable()
export default class ClosersValidator implements IF360ClosersValidator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  handleValidation(): boolean {
    const isCloser = this.userProfileMixin.handleGetUserProfile()?.CodigoCliente
      ? this.userProfileMixin
          .handleGetUserProfile()
          ?.CodigoCliente?.includes("RPS")
        ? true
        : false
      : false;

    return isCloser;
  }
}
